import { Routes } from '@angular/router';
import { KitchenSinkComponent } from './internal/kitchen-sink/kitchen-sink.component';
import { SigninComponent } from './account/signin/signin.component';
import { authGaurd, canActivateChild } from './core/services/auth-gaurd';
import { KpaSidenavComponent } from './shared/components/kpa-sidenav/kpa-sidenav.component';
import { AutoLoginComponent } from './account/auto-login/auto-login.component';
import { AuditViewComponent } from './audit-view/audit-view.component';
import { authAutoLoginGaurd, canActivateAutoChild } from './core/services/auth-autologin-guard';
import { AutoLogoutComponent } from './account/auto-logout/auto-logout.component';
import { SsoCallbackComponent } from './account/sso-callback/sso-callback.component';

export const routes: Routes = [
	{ path: 'kitchensink', component: KitchenSinkComponent },
	{ path: 'signin', component: SigninComponent },
	{ path: 'auto-login/:scheduledAuditId/:assigneeId', component: AutoLoginComponent },
	{ path: 'auto-logout', component: AutoLogoutComponent },
	{ path: 'sso-callback', component: SsoCallbackComponent },
	{
		path: 'audit',
		component: AuditViewComponent,
		canActivate: [authAutoLoginGaurd],
		canActivateChild: [canActivateAutoChild],
		runGuardsAndResolvers: 'always',
	},
	{
		path: '',
		canActivate: [authGaurd],
		canActivateChild: [canActivateChild],
		runGuardsAndResolvers: 'always',
		loadChildren: () => import('./kpa-layout/kpa-layout.module').then((m) => m.KpaLayoutModule),
	},
	{ path: '**', redirectTo: 'signin' },
];
